import { TextField } from '@andritzot/metris-web-ui/inputs/textfield';
import { Grid } from '@andritzot/metris-web-ui/layout/grid';
import { type Control, Controller } from 'react-hook-form';

import { type FormProps } from './types';

interface CommentFieldProps {
  control: Control<FormProps>;
  isCartEmpty: boolean;
}

export function CommentField({ control, isCartEmpty }: Readonly<CommentFieldProps>) {
  return (
    <Grid size={12}>
      <Controller
        name="comment"
        control={control}
        rules={{ required: isCartEmpty ? 'required' : false }}
        render={({ field, fieldState: { error } }) => (
          <TextField
            {...field}
            label={isCartEmpty ? '* Tell us what you are looking for' : 'Additional information'}
            fullWidth
            multiline
            rows={3}
            error={!!error}
            helperText={error?.message}
          />
        )}
      />
    </Grid>
  );
}
